import { render, staticRenderFns } from "./dailyNewspaper.vue?vue&type=template&id=353b1872&scoped=true&"
import script from "./dailyNewspaper.vue?vue&type=script&lang=js&"
export * from "./dailyNewspaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b1872",
  null
  
)

export default component.exports